import { apiClient } from './client';
import type { SignInCredentials, AuthResponse } from '../../types/auth';
import type { Tenant } from '../../types/entities';

export const authApi = {
  /**
   * Sign in as an admin user
   * POST /auth/admin/signin
   */
  adminSignIn: async (credentials: SignInCredentials): Promise<AuthResponse> => {
    return apiClient.post<AuthResponse>('/auth/admin/signin', credentials);
  },

  /**
   * Sign in as a tenant user
   * POST /auth/tenant/signin
   */
  tenantSignIn: async (credentials: SignInCredentials): Promise<AuthResponse> => {
    return apiClient.post<AuthResponse>('/auth/tenant/signin', credentials);
  },

  /**
   * Validate and sign in from partner token
   * POST /auth/partners/:tenantSlug
   */
  partnerSignIn: async (tenantSlug: string, token: string): Promise<AuthResponse> => {
    return apiClient.post<AuthResponse>(`/auth/partners/${tenantSlug}`, { token });
  },

  /**
    * Get the current authenticated tenant's data
    * GET /tenants/current
    */
  getCurrentTenant: async (): Promise<Tenant> => {
    return apiClient.get<Tenant>('/tenants/current');
  },
};
